/**
 * Ids of the developer lessons (docs-page modules in the Learn library).
 * Progress is kept per id on the instance, which only accepts names it
 * knows, so the list lives here; the frontend's lesson declarations are
 * pinned to it by a test.
 */
export const LEARN_LESSON_IDS = [
    'docs:semantic-layer/metrics',
    'docs:semantic-layer/dimensions',
];
/**
 * Subcommands the Learn terminal runs. The server enforces the list (with
 * its flag rules); the browser refuses anything else before asking, so a
 * mistyped command is caught where it is typed.
 */
export const LEARN_TERMINAL_SUBCOMMANDS = {
    lightdash: [
        'compile',
        'deploy',
        'start-preview',
        'validate',
        'lint',
        'download',
        'upload',
    ],
    dbt: ['parse', 'compile', 'ls'],
};
export const LEARN_TERMINAL_REJECTION = 'That command is not available in the Learn terminal';
//# sourceMappingURL=learnSandbox.js.map